import { Box, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSearch } from "@tanstack/react-router";
import Logo from "src/components/Logo";
import Page from "src/components/Page";
import useLocales from "src/hooks/useLocales";

import ChangePasswordForm from "./ChangePasswordForm";
import Context from "./context";
// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
	display: "flex",
	minHeight: "100%",
	alignItems: "center",
	justifyContent: "center",
	padding: theme.spacing(12, 5)
}));

// ----------------------------------------------------------------------

export default function RecoverPassword() {
	const { translate } = useLocales();
	const { token }: { token: string } = useSearch({ strict: false });

	return (
		<Page title={translate("Recuperar contraseña")}>
			<RootStyle>
				<Logo sx={{ position: "absolute", top: 0, mt: 5 }} />
				<Container>
					<Context.Provider value={{ token }}>
						<Box sx={{ maxWidth: 480, mx: "auto" }}>
							<Typography paragraph variant='h3'>
								Reiniciar tu contraseña
							</Typography>
							<Typography sx={{ color: "text.secondary" }}>
								Acontinuación introduce tu nueva contraseña
							</Typography>
							<ChangePasswordForm />
						</Box>
					</Context.Provider>
				</Container>
			</RootStyle>
		</Page>
	);
}
